<template>
  <div class="animated-icon">
    <!-- Spinning Outline -->
    <div class="spinning-outline"></div>
    <!-- Pause Icon -->
    <div class="pause-icon">
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
.animated-icon {
  position: absolute;
  width: 1.75rem;
  height: 1.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.125rem;
  box-sizing: border-box; 
  cursor: pointer;
}

/* Spinning Outline */
.spinning-outline {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  outline-offset: -3px; 
  border-top-color: var(--border-dark);
  background-color: var(--surface-gray);
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

.pause-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  width: 50%;
  height: 0.625rem;
  position: relative;
}

.bar {
  width: 2.5px;
  height: 100%;
  background-color: var(--font-dimmer);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
